import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { startedAt: String }

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    const start = new Date(this.startedAtValue)
    const elapsed = Math.floor((Date.now() - start.getTime()) / 1000)
    if (elapsed < 0) { this.element.textContent = "0:00:00"; return }
    const h = Math.floor(elapsed / 3600)
    const m = Math.floor((elapsed % 3600) / 60)
    const s = elapsed % 60
    this.element.textContent = `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
  }
}
